import { render, staticRenderFns } from "./CarrinhosAbandonados.vue?vue&type=template&id=5f232842&scoped=true&"
import script from "./CarrinhosAbandonados.vue?vue&type=script&lang=js&"
export * from "./CarrinhosAbandonados.vue?vue&type=script&lang=js&"
import style0 from "./CarrinhosAbandonados.vue?vue&type=style&index=0&id=5f232842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f232842",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VBtn,VDataTable,VIcon,VProgressCircular})
